import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LaunchProvider } from './contexts/LaunchContext';
import { CookieBanner } from './components/CookieBanner';
import { Home } from './pages/Home';
import { CookiePolicy } from './pages/CookiePolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Disclaimer } from './pages/Disclaimer';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { About } from './pages/About';
import { DeleteAccount } from './pages/DeleteAccount';
type LaunchState = 'pre-launch' | 'public-launch';
export function App({
  launchState = 'public-launch'
}: {
  launchState?: LaunchState;
}) {
  return <LaunchProvider launchState={launchState} data-id="element-0" data-mp="2wip5j08ate3v">
      <Routes data-id="element-1" data-mp="28tw62tsgwo4i">
        <Route path="/" element={<Home data-id="element-3" data-mp="28sutgkvsztko" />} data-id="element-2" data-mp="28tmi1bqzgr1g" />
        <Route path="/cookie-policy" element={<CookiePolicy data-id="element-5" data-mp="23vune9yyeqtk" />} data-id="element-4" data-mp="28sb9yzqi8x4j" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-7" data-mp="23ti8y6semyl9" />} data-id="element-6" data-mp="23ujkecdc1n3i" />
        <Route path="/terms" element={<TermsAndConditions data-id="element-9" data-mp="3ij652c0mxp8x" />} data-id="element-8" data-mp="3ikh8gaq64uzi" />
        <Route path="/disclaimer" element={<Disclaimer data-id="element-11" data-mp="3ml14tc2x3ukl" />} data-id="element-10" data-mp="3ihv0i9zd8dgr" />
        <Route path="/contact" element={<Contact data-id="element-13" data-mp="3mjpyp5m02aqb" />} data-id="element-12" data-mp="3mkhnnxl3da7m" />
        <Route path="/faq" element={<FAQ data-id="element-15" data-mp="3rbzmog3k10py" />} data-id="element-14" data-mp="3rc9e8848zfxr" />
        <Route path="/about" element={<About data-id="element-17" data-mp="3recf5n6xuth9" />} data-id="element-16" data-mp="3rdkhm6ts6loc" />
        <Route path="/delete-account" element={<DeleteAccount data-id="element-19" data-mp="4wv3njt0sf7" />} data-id="element-18" data-mp="5yj0slx59ec" />
      </Routes>
      <CookieBanner data-id="element-20" data-mp="82jf0klzq9v" />
    </LaunchProvider>;
}